module.exports = __webpack_public_path__ + "img/inactive.a3d513e6.svg";